import http from "@/common/request";
const url = require("../url");

// 获取菜单树
export function GetTreeTable(params) {
  return http.get(url.GetTreeTable, params);
}
// 获取全部菜单树
export function GetPermissionTree(params) {
  return http.get(url.GetPermissionTree, params)
}
// 获取全部API接口
export function GetApiList(params) {
  return http.get(url.GetApiList, params)
}
// 添加菜单
export function PermissionPost(data) {
  return http.post(url.PermissionPost, data)
}
// 更新菜单
export function PermissionPut(data) {
  return http.put(url.PermissionPut, data)
}
// 删除菜单
export function PermissionDelete(params) {
  return http.delete(url.PermissionDelete, params)
}
// 获取全部接口
export function ModuleGet(params) {
  return http.get(url.ModuleGet, params)
}
// 添加接口
export function ModulePost(data) {
  return http.post(url.ModulePost, data)
}
// 更新接口
export function ModulePut(data) {
  return http.put(url.ModulePut, data)
}
// 删除接口
export function ModuleDelete(params) {
  return http.delete(url.ModuleDelete, params)
}
// 获取全部角色
export function RoleGet(params) {
  return http.get(url.RoleGet, params)
}
// 添加角色
export function RolePost(data) {
  return http.post(url.RolePost, data)
}
// 编辑角色
export function RolePut(data) {
  return http.put(url.RolePut, data)
}
// 删除角色
export function RoleDelete(params) {
  return http.delete(url.RoleDelete, params)
}
// 通过角色获取菜单
export function GetPermissionIdByRoleId(params) {
  return http.get(url.GetPermissionIdByRoleId, params)
}
// 保存菜单权限分配
export function PermissionAssign(data) {
  return http.post(url.PermissionAssign, data)
}
// 获取顶部菜单（一级路由）
export function GetRootNavigationBar(params) {
  return http.get(url.GetRootNavigationBar, params)
}
// 通过id获取路由树
export function GetNavigationBarByPid(params) {
  return http.get(url.GetNavigationBarByPid, params)
}
// 服务管理
export function MonitorQuery(data) {
  return http.post(url.MonitorQuery, data)
}
// 查询在线用户
export function OnlineQuery(data) {
  return http.post(url.OnlineQuery, data)
}
// 踢出在线用户
export function OnlineDelete(data) {
  return http.post(url.OnlineDelete, data)
}
// 获取任务命名空间
export function GetTaskNameSpace() {
  return http.get(url.GetTaskNameSpace)
}
// 添加计划任务
export function TasksQzPost(data) {
  return http.post(url.TasksQzPost, data)
}
// 获取计划任务
export function TasksQzGet(params) {
  return http.get(url.TasksQzGet, params)
}
// 修改计划任务
export function TasksQzPut(data) {
  return http.put(url.TasksQzPut, data)
}
// 启动计划任务
export function TasksQzStartJob(params) {
  return http.get(url.TasksQzStartJob, params)
}
// 停止任务
export function TasksQzStopJob(params) {
  return http.get(url.TasksQzStopJob, params)
}
// 删除任务
export function TasksQzDelete(params) {
  return http.delete(url.TasksQzDelete, params)
}
// 获取添加管理员
export function UserGetAddmin(params) {
  return http.get(url.UserGetAddmin, params)
}
// 添加管理员
export function UserPostAdmin(data) {
  return http.post(url.UserPostAdmin, data)
}
// 修改管理员
export function UserPut(data) {
  return http.put(url.UserPut, data)
}

// 修改管理员
export function UserDelete(params) {
  return http.delete(url.UserDelete, params)
}
// 删除管理员
export function Delete(params) {
  return http.delete(url.Delete, params)
}

// 重置管理员密码
export function UpdatePwd(params) {
  return http.post(url.UpdatePwd, params)
}
// 获取敏感词
export function SensitiveWordsQueryBlackIp(data) {
  return http.post(url.SensitiveWordsQueryBlackIp, data)
}
// 添加敏感词
export function AddSensitiveWords(data) {
  return http.post(url.AddSensitiveWords, data)
}
// 修改敏感词
export function UpdateSensitiveWords(data) {
  return http.post(url.UpdateSensitiveWords, data)
}
// 删除敏感词
export function DeleteSensitiveWords(params) {
  return http.get(url.DeleteSensitiveWords, params)
}
// 查询黑名单
export function QueryBlackIp(data) {
  return http.post(url.QueryBlackIp, data)
}
// 添加黑名单
export function AddBlackIp(data) {
  return http.post(url.AddBlackIp, data)
}
// 修改黑名单
export function UpdateBlackIp(data) {
  return http.post(url.UpdateBlackIp, data)
}
// 删除黑名单
export function DeleteBlackIp(data) {
  return http.get(url.DeleteBlackIp, data)
}
// 获取课程类型
export function CClassifyQuery(data) {
  return http.post(url.CClassifyQuery, data)
}
// 课程类型开放禁用
export function CClassifyControlState(data) {
  return http.post(url.CClassifyControlState, data)
}
// 添加课程类型
export function CClassifyPost(data) {
  return http.post(url.CClassifyPost, data)
}
// 修改课程类型
export function CClassifyPut(data) {
  return http.put(url.CClassifyPut, data)
}
// 删除课程类型
export function CClassifyDelete(params) {
  return http.delete(url.CClassifyDelete, params)
}
// 查询课程专题
export function CSSubjectQuery(data) {
  return http.post(url.CSSubjectQuery, data)
}
// 课程专题状态修改
export function CSSubjectControlState(data) {
  return http.post(url.CSSubjectControlState, data)
}
// 添加课程专题
export function CSSubjectPost(data) {
  return http.post(url.CSSubjectPost, data)
}
// 修改课程专题
export function CSSubjectPut(data) {
  return http.put(url.CSSubjectPut, data)
}
// 删除课程专题
export function CSSubjectDelete(params) {
  return http.delete(url.CSSubjectDelete, params)
}
// 查询行业领域
export function IndustryClassifyQuery(data) {
  return http.post(url.IndustryClassifyQuery, data)
}
// 行业领域状态修改
export function IndustryClassifyControlState(data) {
  return http.post(url.IndustryClassifyControlState, data)
}
// 添加行业领域
export function IndustryClassifyPost(data) {
  return http.post(url.IndustryClassifyPost, data)
}
// 修改行业领域
export function IndustryClassifyPut(data) {
  return http.put(url.IndustryClassifyPut, data)
}
// 删除行业领域
export function IndustryClassifyDelete(params) {
  return http.delete(url.IndustryClassifyDelete, params)
}
// 获取企业信息
export function GetEnterprise(data) {
  return http.get(url.GetEnterprise, data)
}
// 删除企业信息
export function DeleteEnterprise(params) {
  return http.delete(url.DeleteEnterprise, params)
}
// 修改企业信息
export function PutEnterprise(data) {
  return http.put(url.PutEnterprise, data)
}
// 超级管理员获取用户信息
export function SuperGetAllUsers(data) {
  return http.post(url.SuperGetAllUsers, data)
}
// 管理员获取用户身份证照片
export function GetUserPhotoData(data) {
  return http.get(url.GetUserPhotoData, data)
}
// 管理员获取用户课程
export function AdminGetUserCourseQuery(data) {
  return http.post(url.AdminGetUserCourseQuery, data)
}

// 管理员获取用户积分
export function IntegralOriginAdminQuery(data) {
  return http.post(url.IntegralOriginAdminQuery, data)
}

// 管理员获取用户收藏
export function AdminCollectQuery(data) {
  return http.post(url.AdminCollectQuery, data)
}
// 更改企业类型状态
export function ConstrolState(data) {
  return http.post(url.ConstrolState, data)
}
// 查询机构企业信息
export function QueryInstitution(data) {
  return http.post(url.QueryInstitution, data)
}
// 获取个人工作经历
export function identityresumePage(data) {
  return http.post(url.identityresumePage, data)
}
// 获取素材类型
export function SMClassifyQuery(data) {
  return http.post(url.SMClassifyQuery, data)
}
// 素材类型状态修改
export function SMClassifyControlState(data) {
  return http.post(url.SMClassifyControlState, data)
}
// 添加素材类型
export function SMClassifyPost(data) {
  return http.post(url.SMClassifyPost, data)
}
// 修改素材类型
export function SMClassifyPut(data) {
  return http.put(url.SMClassifyPut, data)
}
// 删除素材类型
export function SMClassifyDelete(params) {
  return http.delete(url.SMClassifyDelete, params)
}
// 获取试题类别
export function QuestionClassifyQuery(data) {
  return http.post(url.QuestionClassifyQuery, data)
}
// 试题类别状态修改
export function QuestionClassifyControlState(data) {
  return http.post(url.QuestionClassifyControlState, data)
}
// 添加试题类别
export function QuestionClassifyPost(data) {
  return http.post(url.QuestionClassifyPost, data)
}
// 修改试题类别
export function QuestionClassifyPut(data) {
  return http.put(url.QuestionClassifyPut, data)
}
// 删除试题类别
export function QuestionClassifyDelete(params) {
  return http.delete(url.QuestionClassifyDelete, params)
}
// 获取试卷类别
export function PaperClassifyQuery(data) {
  return http.post(url.PaperClassifyQuery, data)
}
// 试卷类别状态修改
export function PaperClassifyControlState(data) {
  return http.post(url.PaperClassifyControlState, data)
}
// 添加试卷类别
export function PaperClassifyPost(data) {
  return http.post(url.PaperClassifyPost, data)
}
// 修改试卷类别
export function PaperClassifyPut(data) {
  return http.put(url.PaperClassifyPut, data)
}
// 删除试卷类别
export function PaperClassifyDelete(params) {
  return http.delete(url.PaperClassifyDelete, params)
}
// 获取计划类别
export function PlanClassifyQuery(data) {
  return http.post(url.PlanClassifyQuery, data)
}
// 计划类别状态修改
export function PlanClassifyControlState(data) {
  return http.post(url.PlanClassifyControlState, data)
}
// 添加计划类别
export function PlanClassifyPost(data) {
  return http.post(url.PlanClassifyPost, data)
}
// 修改计划类别
export function PlanClassifyPut(data) {
  return http.put(url.PlanClassifyPut, data)
}
// 删除计划类别
export function PlanClassifyDelete(params) {
  return http.delete(url.PlanClassifyDelete, params)
}
// 获取企业类别
export function EntepriseClassifyQuery(data) {
  return http.post(url.EntepriseClassifyQuery, data)
}
// 企业类别状态修改
export function EntepriseClassifyControlState(data) {
  return http.post(url.EntepriseClassifyControlState, data)
}
// 添加企业类别
export function EntepriseClassifyPost(data) {
  return http.post(url.EntepriseClassifyPost, data)
}
// 修改企业类别
export function EntepriseClassifyPut(data) {
  return http.put(url.EntepriseClassifyPut, data)
}
// 删除企业类别
export function EntepriseClassifyDelete(params) {
  return http.delete(url.EntepriseClassifyDelete, params)
}
// 获取培训类别（树结构）
export function TrainClassifyQuery(params) {
  return http.get(url.TrainClassifyQuery, params)
}
// 添加培训类别
export function TrainClassifyPost(data) {
  return http.post(url.TrainClassifyPost, data)
}
// 修改培训类别
export function TrainClassifyPut(data) {
  return http.put(url.TrainClassifyPut, data)
}
// 删除培训类别
export function TrainClassifyDelete(params) {
  return http.delete(url.TrainClassifyDelete, params)
}
// 获取组织架构
export function DepartmentGetTreeTable(params) {
  return http.get(url.DepartmentGetTreeTable, params)
}
// 添加部门
export function DepartmentPost(data) {
  return http.post(url.DepartmentPost, data)
}
// 修改部门
export function DepartmentPut(data) {
  return http.put(url.DepartmentPut, data)
}
// 删除部门
export function DepartmentDelete(params) {
  return http.delete(url.DepartmentDelete, params)
}
// 获取岗位
export function AppointmentQuery(data) {
  return http.post(url.AppointmentQuery, data)
}
// 添加岗位
export function AppointmentPost(data) {
  return http.post(url.AppointmentPost, data)
}
// 修改岗位
export function AppointmentPut(data) {
  return http.put(url.AppointmentPut, data)
}
// 删除岗位
export function AppointmentDelete(params) {
  return http.delete(url.AppointmentDelete, params)
}
// 企业获取用户列表
export function EntGetAllUsers(data) {
  return http.post(url.EntGetAllUsers, data)
}
// 获取部门树
export function GetDepartmentTree(params) {
  return http.get(url.GetDepartmentTree, params)
}
// 管理员添加用户
export function UserPost(data) {
  return http.post(url.UserPost, data)
}
// 管理员更新用户信息
export function EntPostUserInfo(data) {
  return http.post(url.EntPostUserInfo, data)
}
// 获取素材库
export function smlibraryGet(data) {
  return http.post(url.smlibraryGet, data)
}
export function smlibraryGetById(params) {
  return http.get(url.smlibraryGetById, params)
}
// 创建素材库
export function smlibraryPost(data) {
  return http.post(url.smlibraryPost, data)
}
//素材库切换发布状态
export function smlibraryPublishState(data) {
  return http.post(url.smlibraryPublishState, data)
}
// 修改素材库
export function smlibraryPut(data) {
  return http.put(url.smlibraryPut, data)
}
// 删除素材库
export function smlibraryDelete(params) {
  return http.delete(url.smlibraryDelete, params)
}
// 获取学员审核列表
export function UserAuditAdminQuery(data) {
  return http.post(url.UserAuditAdminQuery, data)
}
// 审核
export function UserAuditAudit(data) {
  return http.post(url.UserAuditAudit, data)
}
// 企业申请列表
export function EnterpriseAuditQuery(data) {
  return http.post(url.EnterpriseAuditQuery, data)
}
// 审核企业
export function EnterpriseAuditAudit(data) {
  return http.post(url.EnterpriseAuditAudit, data)
}
// 企业管理查询素材
export function smfilepackEntGet(data) {
  return http.post(url.smfilepackEntGet, data)
}
// 下载用户导入模板
export function ExportUserTemplate() {
  return http.get(url.ExportUserTemplate)
}
// 批添加用户
export function UploadUsers(data) {
  return http.post(url.UploadUsers, data)
}
// 天翼云上传创建视频
export function TYYCreatVideo(data) {
  return http.post(url.TYYCreatVideo, data)
}
// 天翼云创建转码任务
export function CreatTransCodeTask(data) {
  return http.post(url.CreatTransCodeTask, data)
}
// 获取转码后地址
export function GetTransCodeVideoUrl(data) {
  return http.post(url.GetTransCodeVideoUrl, data)
}
// 获取转码进度
export function queryTaskProcess(data) {
  return http.post(url.queryTaskProcess, data)
}
// 获取转码进度
export function GetS3TaskProcess(params){
  return http.get(url.GetS3TaskProcess,params)
}
// 添加素材
export function smfilepackPost(data) {
  return http.post(url.smfilepackPost, data)
}
// 删除素材
export function smfilepackDelete(params) {
  return http.delete(url.smfilepackDelete, params)
}
// 编辑素材
export function smfilepackPut(data){
  return http.put(url.smfilepackPut,data)
}
// 上传文档文件
export function UploadFileToRemote(data) {
  return http.post(url.UploadFileToRemote, data)
}
// 创建题库
export function QuestionLibraryPost(data) {
  return http.post(url.QuestionLibraryPost, data)
}
// 获取题库列表
export function QuestionLibraryQuery(data) {
  return http.post(url.QuestionLibraryQuery, data)
}
// 切换题库发布状态
export function QuestionLibraryChangePublishState(data) {
  return http.post(url.QuestionLibraryChangePublishState, data)
}
// 修改题库
export function QuestionLibraryPut(data) {
  return http.put(url.QuestionLibraryPut, data)
}
// 删除题库
export function QuestionLibraryDelete(params) {
  return http.delete(url.QuestionLibraryDelete, params)
}
// 获取题库信息
export function QuestionLibraryGet(params) {
  return http.get(url.QuestionLibraryGet, params)
}
// 设置题库试卷
export function SetLibPaperSet(data){
  return http.post(url.SetLibPaperSet,data)
}
// 获取题库试卷设置
export function GetLibPaperSet(params){
  return http.get(url.GetLibPaperSet,params)
}
// 获取试题列表
export function QuestionQuery(data) {
  return http.post(url.QuestionQuery, data)
}
// 添加试题
export function QuestionPost(data) {
  return http.post(url.QuestionPost, data)
}
// 试题导入模板
export function ExportQuestionTemplate() {
  return http.get(url.ExportQuestionTemplate)
}
// 批量上传试题
export function UploadQuestion(data) {
  return http.post(url.UploadQuestion, data)
}
// 修改试题
export function QuestionPut(data) {
  return http.post(url.QuestionPut, data)
}
// 删除试题
export function QuestionDelete(params) {
  return http.delete(url.QuestionDelete, params)
}
// 清空题库试题
export function DelLibraryAllQuestion(params){
  return http.delete(url.DelLibraryAllQuestion,params)
}
// 获取试题详情
export function QuestionGet(params) {
  return http.get(url.QuestionGet, params)
}
// 查询试卷
export function PaperQuery(data) {
  return http.post(url.PaperQuery, data)
}
// 创建试卷
export function PaperPost(data) {
  return http.post(url.PaperPost, data)
}
// 获取试卷详情
export function PaperGet(params) {
  return http.get(url.PaperGet, params)
}
// 试卷修改
export function PaperPut(data) {
  return http.put(url.PaperPut, data)
}
// 删除试卷
export function PaperDelete(params) {
  return http.delete(url.PaperDelete, params)
}
// 更新试卷发布状态
export function PaperUpdatePublishState(data) {
  return http.post(url.PaperUpdatePublishState, data)
}
// 随机添加试题
export function RandomAddQuestions(data) {
  return http.post(url.RandomAddQuestions, data)
}
// 查询已添加试题
export function PaperQuestionQuery(data) {
  return http.post(url.PaperQuestionQuery, data)
}
// 手动批量添加试题
export function BatchAddQuestions(data) {
  return http.post(url.BatchAddQuestions, data)
}
// 删除已选试题
export function PaperQuestionDelete(data) {
  return http.post(url.PaperQuestionDelete, data)
}
// 添加练习到试卷
export function PaperAddLibrary(data) {
  return http.post(url.PaperAddLibrary, data)
}
// 创建课程
export function CoursePost(data) {
  return http.post(url.CoursePost, data)
}
// 查询课程列表
export function CourseQuery(data) {
  return http.post(url.CourseQuery, data)
}
// 课程删除
export function CourseDelete(params) {
  return http.delete(url.CourseDelete, params)
}
// 切换发布状态
export function CourseUpdatePublishState(data) {
  return http.post(url.CourseUpdatePublishState, data)
}
// 获取课程详情
export function CourseGet(params) {
  return http.get(url.CourseGet, params)
}
// 修改课程信息
export function CoursePut(data) {
  return http.put(url.CoursePut, data)
}
// 获取课程目录
export function CatalogueGet(params) {
  return http.get(url.CatalogueGet, params)
}
// 获取目录树形
export function CatalogueQueryTree(params) {
  return http.get(url.CatalogueQueryTree, params)
}
// 获取课程目录
export function GetCourseCatalogue(data) {
  return http.post(url.GetCourseCatalogue, data)
}
// 添加章节
export function CataloguePost(data) {
  return http.post(url.CataloguePost, data)
}
// 编辑章节
export function CataloguePut(data) {
  return http.put(url.CataloguePut, data)
}
// 删除章节
export function CatalogueDelete(params) {
  return http.delete(url.CatalogueDelete, params)
}
// 课时批量添加
export function CourseHourBatchAdd(data) {
  return http.post(url.CourseHourBatchAdd, data)
}
// 课程查询素材
export function smfilepackCourseGet(data) {
  return http.post(url.smfilepackCourseGet, data)
}
// 企业管理员查询素材库
export function smlibraryAdminGet(data) {
  return http.post(url.smlibraryAdminGet, data)
}
// 删除目录
export function CourseHourDelete(params) {
  return http.delete(url.CourseHourDelete, params)
}
// 添加课件和扩展阅读
export function CourseFilePost(data) {
  return http.post(url.CourseFilePost, data)
}
// 课程和扩展阅读查询
export function CourseFileQuery(data) {
  return http.post(url.CourseFileQuery, data)
}
// 课件和扩展阅读修改
export function CourseFilePut(data) {
  return http.put(url.CourseFilePut, data)
}
// 删除课件和扩展阅读
export function CourseFileDelete(params) {
  return http.delete(url.CourseFileDelete, params)
}
// 创建培训计划
export function PlanPost(data) {
  return http.post(url.PlanPost, data)
}
// 查询企业计划
export function PlanQuery(data) {
  return http.post(url.PlanQuery, data)
}
// 获取计划学员列表
export function GetPlanUserList(data) {
  return http.post(url.GetPlanUserList, data)
}
// 获取计划未勾选学员
export function GetPlanUserListNoCheck(data) {
  return http.post(url.GetPlanUserListNoCheck, data)
}
// 计划批量添加学员
export function PlanBatchAddUser(data) {
  return http.post(url.PlanBatchAddUser, data)
}
// 获取计划详情
export function PlanGet(params) {
  return http.get(url.PlanGet, params)
}
// 删除计划
export function PlanDelete(params) {
  return http.delete(url.PlanDelete, params)
}
// 修改培训计划
export function PlanPut(data){
  return http.put(url.PlanPut,data)
}
// 复制计划
export function CopyPlan(data){
  return http.post(url.CopyPlan,data)
}
// 获取计划未勾选课程
export function GetCourseListNoCheck(data) {
  return http.post(url.GetCourseListNoCheck, data)
}
// 计划添加课程
export function PlanAndCourseAddCourseList(data) {
  return http.post(url.PlanAndCourseAddCourseList, data)
}
// 获取计划课程列表
export function PlanAndCourseQueryCourseList(data) {
  return http.post(url.PlanAndCourseQueryCourseList, data)
}
// 计划课程查询用户进度
export function PlanAndCoursePagerUserQuery(data) {
  return http.post(url.PlanAndCoursePagerUserQuery, data)
}
// 删除计划课程
export function PlanAndCourseDelete(params) {
  return http.delete(url.PlanAndCourseDelete, params)
}
// 切换计划发布状态
export function PlanChangePublishState(data) {
  return http.post(url.PlanChangePublishState, data)
}
// 获取计划内的试卷列表
export function PlanAndPaperQueryCourseList(data) {
  return http.post(url.PlanAndPaperQueryCourseList, data)
}
// 计划试卷查询用户进度
export function PlanAndPaperPagerUserQuery(data) {
  return http.post(url.PlanAndPaperPagerUserQuery, data)
}
// 获取未勾选试卷列表
export function PlanAndPaperGetPaperListNoCheck(data) {
  return http.post(url.PlanAndPaperGetPaperListNoCheck, data)
}
// 计划添加试卷
export function PlanAndPaperAddCourseList(data) {
  return http.post(url.PlanAndPaperAddCourseList, data)
}
// 删除试卷
export function PlanAndPaperDelete(params) {
  return http.delete(url.PlanAndPaperDelete, params)
}
// 运营查询题库列表
export function OperateQuery(data) {
  return http.post(url.OperateQuery, data)
}
//平台运营添加授权
export function PostAuthQuestionBank(data) {
  return http.post(url.PostAuthQuestionBank, data)
}
// 获取授权人
export function GetUserList(data) {
  return http.post(url.GetUserList, data)
}
//获取企业
export function GetEnterpriseList(data) {
  return http.post(url.GetEnterpriseList, data)
}
// 运营查询课程
export function CourseOperateQuery(data) {
  return http.post(url.CourseOperateQuery, data)
}
// 课程查询可授权的人
export function AuthCourseGetUserList(data) {
  return http.post(url.AuthCourseGetUserList, data)
}
// 课程查询可授权企业
export function AuthCourseGetEnterpriseList(data) {
  return http.post(url.AuthCourseGetEnterpriseList, data)
}
// 课程运营授权
export function AuthCoursePost(data) {
  return http.post(url.AuthCoursePost, data)
}
// 运营查询素材库
export function smlibraryOperateGet(data) {
  return http.post(url.smlibraryOperateGet, data)
}
// 课程查询可授权的人
export function AuthSmlibraryGetUserList(data) {
  return http.post(url.AuthSmlibraryGetUserList, data)
}
// 课程查询可授权企业
export function AuthSmlibraryGetEnterpriseList(data) {
  return http.post(url.AuthSmlibraryGetEnterpriseList, data)
}
// 课程运营授权
export function AuthSmlibraryPost(data) {
  return http.post(url.AuthSmlibraryPost, data)
}
// 平台运营课程上下架
export function CourseOperateUpdateOnlineState(data) {
  return http.post(url.CourseOperateUpdateOnlineState, data)
}
// 运营课程推荐
export function CourseOperateRecommendState(data) {
  return http.post(url.CourseOperateRecommendState, data)
}
// 运营课程精品
export function CourseOperateBoutiqueState(data) {
  return http.post(url.CourseOperateBoutiqueState, data)
}
// 平台运营题库上下架
export function BankOnlineState(data) {
  return http.post(url.BankOnlineState, data)
}
// 素材库上下架
export function SmlibraryOnSmLib(data) {
  return http.post(url.SmlibraryOnSmLib, data)
}
// 素材库设置精选
export function smlibrarySetBoutiqueState(params) {
  return http.get(url.smlibrarySetBoutiqueState, params)
}
// 素材库推荐
export function smlibrarySetRecommendState(params) {
  return http.get(url.smlibrarySetRecommendState, params)
}
//订单查询
export function AdminOrderQuery(data) {
  return http.post(url.AdminOrderQuery, data)
}
// 获取每日一练
export function EveryDayTaskQuery(data) {
  return http.get(url.EveryDayTaskQuery, data)
}
// 添加每日一练
export function EveryDayTaskPost(data) {
  return http.post(url.EveryDayTaskPost, data)
}
// 修改每日一练
export function EveryDayTaskPut(data) {
  return http.put(url.EveryDayTaskPut, data)
}
// 删除每日一练
export function EveryDayTaskDelete(data) {
  return http.delete(url.EveryDayTaskDelete, data)
}
// 添加每周一课
export function EveryWeekTaskPost(data) {
  return http.post(url.EveryWeekTaskPost, data)
}
// 获取每周一课
export function EveryWeekTaskQuery(data) {
  return http.post(url.EveryWeekTaskQuery, data)
}
// 修改每周一课
export function EveryWeekTaskPut(data) {
  return http.put(url.EveryWeekTaskPut, data)
}
// 删除每周一课
export function EveryWeekTaskDelete(params) {
  return http.delete(url.EveryWeekTaskDelete, params)
}
// 获取每月一考
export function EveryMonthTaskQuery(data) {
  return http.get(url.EveryMonthTaskQuery, data)
}
// 添加每月一考
export function EveryMonthTaskPost(data) {
  return http.post(url.EveryMonthTaskPost, data)
}
// 修改每月一考
export function EveryMonthTaskPut(data) {
  return http.put(url.EveryMonthTaskPut, data)
}
// 删除每月一考
export function EveryMonthTaskDelete(data) {
  return http.delete(url.EveryMonthTaskDelete, data)
}
// 查询物理空间
export function PhysicalSpaceQuery(data) {
  return http.post(url.PhysicalSpaceQuery, data)
}
// 添加物理空间
export function PhysicalSpacePost(data) {
  return http.post(url.PhysicalSpacePost, data)
}
// 修改物理空间
export function PhysicalSpacePut(data) {
  return http.put(url.PhysicalSpacePut, data)
}
// 删除物理空间
export function PhysicalSpaceDelete(params) {
  return http.delete(url.PhysicalSpaceDelete, params)
}
// 获取区域设备列表
export function QueryAllRegion(data) {
  return http.post(url.QueryAllRegion, data)
}
// 获取监控设备
export function PhyRegionGetAllCamera(params){
  return http.get(url.PhyRegionGetAllCamera,params)
}
// 查询登录记录
export function PhysicalSpaceGetPhysicsLogin(data){
  return http.post(url.PhysicalSpaceGetPhysicsLogin,data)
}
// 添加区域
export function PhyRegionPost(data) {
  return http.post(url.PhyRegionPost, data)
}
// 修改区域
export function PhyRegionPut(data) {
  return http.put(url.PhyRegionPut, data)
}
// 删除区域
export function PhyRegionDelete(params) {
  return http.delete(url.PhyRegionDelete, params)
}
// 计划查询可添加区域
export function GetNoUseRegionList(params) {
  return http.get(url.GetNoUseRegionList, params)
}
// 计划添加区域
export function PlanPhyRegionPost(data) {
  return http.post(url.PlanPhyRegionPost, data)
}
// 查询计划内区域列表
export function PlanPhyRegionQuery(data) {
  return http.post(url.PlanPhyRegionQuery, data)
}
// 删除计划内区域
export function PlanPhyRegionDelete(params) {
  return http.delete(url.PlanPhyRegionDelete, params)
}
// 获取计划内可添加的设备
export function GetNoUseDeivceList(params) {
  return http.get(url.GetNoUseDeivceList, params)
}
// 查询计划设备列表
export function PlanPhyDeviceQuery(data) {
  return http.post(url.PlanPhyDeviceQuery, data)
}
// 计划区域添加设备
export function PlanPhyDevicePost(data) {
  return http.post(url.PlanPhyDevicePost, data)
}
// 删除计划区域设备
export function PlanPhyDeviceDelete(params) {
  return http.delete(url.PlanPhyDeviceDelete, params)
}

// 管理员查询软件
export function SoftwareQuery(data) {
  return http.post(url.SoftwareQuery, data)
}
//管理员添加软件
export function SoftwarePost(data) {
  return http.post(url.SoftwarePost, data)
}
// 管理员修改软件
export function SoftwarePut(data) {
  return http.put(url.SoftwarePut, data)
}
//管理员删除软件
export function SoftwareDelete(params) {
  return http.delete(url.SoftwareDelete, params)
}
//管理员获取软件详情
export function SoftwareGet(params) {
  return http.get(url.SoftwareGet, params)
}
// 查询软件工况列表
export function workingconditionQuery(params) {
  return http.get(url.workingconditionQuery,params)
}
// 添加工况
export function workingconditionPost(data){
  return http.post(url.workingconditionPost,data)
}
// 修改工况
export function workingconditionPut(data){
  return http.put(url.workingconditionPut,data)
}
// 删除工况
export function workingconditionDelete(params){
  return http.delete(url.workingconditionDelete,params)
}
//修改软件发布状态
export function SoftwarePublishState(data) {
  return http.post(url.SoftwarePublishState, data)
}
//管理员查询软件上下架状态
export function SoftwareOnlineState(data) {
  return http.post(url.SoftwareOnlineState, data)
}
// 运营查询软件
export function SoftwareOperateQuery(data) {
  return http.post(url.SoftwareOperateQuery, data)
}
// 运营更新软件精品
export function SoftwareOperateBoutiqueState(data) {
  return http.post(url.SoftwareOperateBoutiqueState, data)
}
// 运营更新软件推荐
export function SoftwareOperateRecommendState(data) {
  return http.post(url.SoftwareOperateRecommendState, data)
}
//运营软件授权
export function AuthSoftwarePost(data) {
  return http.post(url.AuthSoftwarePost, data)
}
// 查询新闻列表
export function NewsQuery(data) {
  return http.post(url.NewsQuery, data)
}
// 修改新闻发布状态
export function NewsChangePublishState(params) {
  return http.get(url.NewsChangePublishState, params)
}
// 修改新闻置顶状态
export function NewsChangeTopState(params) {
  return http.get(url.NewsChangeTopState, params)
}
// 添加新闻
export function NewsPost(data) {
  return http.post(url.NewsPost, data)
}
// 修改新闻
export function NewsPut(data) {
  return http.put(url.NewsPut, data)
}
// 删除新闻
export function NewsDelete(params) {
  return http.delete(url.NewsDelete, params)
}
// 查询公告
export function NoticeQuery(data) {
  return http.post(url.NoticeQuery, data)
}
// 添加公告
export function NoticePost(data) {
  return http.post(url.NoticePost, data)
}
// 修改公告
export function NoticePut(data) {
  return http.put(url.NoticePut, data)
}
// 删除公告
export function NoticeDelete(params) {
  return http.delete(url.NoticeDelete, params)
}
// 修改公告发布状态
export function NoticeChangePublishState(params) {
  return http.get(url.NoticeChangePublishState, params)
}
//获取软件企业授权
export function AuthSoftwareGetEnterpriseList(data) {
  return http.post(url.AuthSoftwareGetEnterpriseList, data)
}
//获取软件个人授权
export function AuthSoftwareGetUserList(data) {
  return http.post(url.AuthSoftwareGetUserList, data)
}

//软件切片上传
export function ImgSoftwareUpload(data) {
  return http.post(url.ImgSoftwareUpload, data)
}
// 查询公告管理
export function AdvertisementQuery(data) {
  return http.post(url.AdvertisementQuery, data)
}
// 题库设置精品
export function QuestionLibrarySetBoutiqueState(params) {
  return http.get(url.QuestionLibrarySetBoutiqueState, params)
}
// 题库设置推荐
export function QuestionLibrarySetRecommendState(params) {
  return http.get(url.QuestionLibrarySetRecommendState, params)
}
//培训教师
export function LecturerQuery(data) {
  return http.post(url.LecturerQuery, data)
}
//培训教师添加
export function LecturerPost(data) {
  return http.post(url.LecturerPost, data)
}
// 培训教室详情
export function LecturerGet(params) {
  return http.get(url.LecturerGet, params)
}
// 培训教师删除
export function LecturerDelete(params) {
  return http.delete(url.LecturerDelete, params)
}
// 培训教师修改
export function LecturerPut(data) {
  return http.put(url.LecturerPut, data)
}
// 按角色查询用户
export function UserAdminGetRoleUser(data) {
  return http.post(url.UserAdminGetRoleUser, data)
}
// 计划批量导入用户
export function PlanUploadUsers(data) {
  return http.post(url.PlanUploadUsers, data)
}
// 查询所以企业列表
export function EnterpriseQueryAll(params) {
  return http.get(url.EnterpriseQueryAll, params)
}
// 总管理员添加普通用户
export function UserSuperPostUser(data) {
  return http.post(url.UserSuperPostUser, data)
}
// 总管理员添加企业用户
export function UserSuperPostEnterpriseUser(data) {
  return http.post(url.UserSuperPostEnterpriseUser, data)
}
// 获取计划课程课时
export function GetPlanCourseChList(params) {
  return http.get(url.GetPlanCourseChList, params)
}
// 获取讲师列表
export function LecturerQueryAll(params) {
  return http.get(url.LecturerQueryAll, params)
}

// 更新计划课程学时
export function UpdatePlanCourse(data){
  return http.post(url.UpdatePlanCourse,data)
}
// 管理员修改教师角色
export function EntChangeTeacherRole(data){
  return http.post(url.EntChangeTeacherRole,data)
}

// 管理员获取用户计划列表
export function OwnPlanAdminQuery(data){
  return http.post(url.OwnPlanAdminQuery,data)
}
// 获取计划学员进度
export function PlanGetExportPlanData(params){
  return http.get(url.PlanGetExportPlanData,params)
}
//获取资格类型统计
export function GetCCStatistics(params) {
  return http.get(url.GetCCStatistics, params)
}
// 获取计划列表统计
export function GetPlantatistics(data){
  return http.post(url.GetPlantatistics,data)
}
// 获取培训类型统计
export function GetTrainTypeStatistics(params) {
  return http.get(url.GetTrainTypeStatistics, params)
}
// 获取用户每月新增学员
export function GetUserMonthAddedStatistics(params) {
  return http.get(url.GetUserMonthAddedStatistics, params)
}
// 获取用户统计
export function GetUserStatistics(params) {
  return http.get(url.GetUserStatistics, params)
}
// 计划删除学员
export function PlanDelPlanUser(data){
  return http.post(url.PlanDelPlanUser,data)
}
// 管理员获取用户密码
export function UserAdminUpdateUserPwd(data){
  return http.post(url.UserAdminUpdateUserPwd,data)
}
// 获取企业用户统计
export function StatisticsGetUserStatistics(){
  return http.get(url.StatisticsGetUserStatistics)
}
// 获取每月新增学员
export function StatisticsGetUserMonthAddedStatistics(){
  return http.get(url.StatisticsGetUserMonthAddedStatistics)
}
// 获取培训类型统计
export function StatisticsGetTrainTypeStatistics(){
  return http.get(url.StatisticsGetTrainTypeStatistics)
}
// 获取资格类型统计
export function StatisticsGetCCStatistics(){
  return http.get(url.StatisticsGetCCStatistics)
}
// 计划统计列表
export function StatisticsGetPlantatistics(data){
  return http.post(url.StatisticsGetPlantatistics,data)
}
// 部门批量导入学员
export function DepartmentDepartmentImportUsers(data){
  return http.post(url.DepartmentDepartmentImportUsers,data)
}
// 获取章节模板
export function ExportCatalogueTemplate(){
  return http.get(url.ExportCatalogueTemplate)
}
// 批量导入章节
export function CatalogueImportCatalogue(data){
  return http.post(url.CatalogueImportCatalogue,data)
}
// 根据行业领域获取课程专题
export function IndustryClassifyGetListByCsId(params){
  return http.get(url.IndustryClassifyGetListByCsId,params)
}
// 查询已发布试卷列表
export function PaperQueryAll(params){
  return http.get(url.PaperQueryAll,params)
}
// 查询已发布题库
export function QuestionLibraryQueryAll(params){
  return http.get(url.QuestionLibraryQueryAll,params)
}
// 管理员获取计划模拟记录
export function GetPlanPaperRecordList(params){
  return http.post(url.GetPlanPaperRecordList,params)
}
// 生成学员学时证明
export function GetPlanUserProve(data){
  return http.post(url.GetPlanUserProve,data)
}
// 大数据线下物理空间
export function StatisticsGetOfflinePhySpaceData(params){
  return http.get(url.StatisticsGetOfflinePhySpaceData,params)
}
// 大数据获取企业基础信息
export function StatisticsGetEnterpriseStatisData(params){
  return http.get(url.StatisticsGetEnterpriseStatisData,params)
}
// 推送计划至培训平台
export function PushPlanToTrainPlatfom(data){
  return http.post(url.PushPlanToTrainPlatfom,data)
}
